import List from "@/components/list";
import router from "@/router";
import Bus from "./Bus.js";
const Table = (args) => {
  const { listeners } = args;
  const RCSelectionChange = args.listeners["selection-change"] || function() {};
  const changePort = listeners["change-port"] || function() {};

  function handleDelete({ row }) {
    Bus.$emit("deleteVideoSet", row);
  }
  function handleUpdate({ row }) {
    router.push({
      path: "/videoSet/edit",
      query: {
        uuid: row.uuid,
      },
    });
  }
  function upLine({ row }) {
    Bus.$emit("upLine", row);
  }
  function downLine({ row }) {
    Bus.$emit("downLine", row);
  }

  function shareManage(id) {
    Bus.$emit("shareManage", id);
  }
  function qrcodeClick(val) {
    Bus.$emit("qrcodeClick", val);
  }
  const Deal = ({ props: { vo } }) => {
    const videoSet = vo.row;
    const dealConf = [];
    const canNotEdit = videoSet.enableShared == 0 || videoSet.onlineStatus == 1;
    const canQrCode =
      videoSet.displayTypeName.indexOf("小程序") != -1 &&
      videoSet.onlineStatus == 1;
    if (canNotEdit) {
      dealConf.push(["icon-edit-disable", "编辑", () => {}, "videoSet:update"]);
    } else {
      dealConf.push([
        "icon-edit",
        "编辑",
        () => handleUpdate(vo),
        "videoSet:update",
      ]);
    }

    if (videoSet.onlineStatus == 1) {
      dealConf.push([
        "icon-delete-disable",
        "删除",
        () => {},
        "videoSet:delete",
      ]);
      dealConf.push([
        "icon-down",
        "下线",
        () => downLine(vo),
        "videoSet:online",
      ]);
    } else {
      dealConf.push([
        "icon-delete",
        "删除",
        () => handleDelete(vo),
        "videoSet:delete",
      ]);
      dealConf.push(["icon-up", "上线", () => upLine(vo), "videoSet:online"]);
    }

    if (videoSet.enableShared) {
      dealConf.push([
        "icon-share",
        "共享管理",
        () => shareManage(videoSet.uuid),
        "videoSet:sharePage",
      ]);
    } else {
      dealConf.push([
        "icon-share-none",
        "共享管理",
        () => {},
        "videoSet:sharePage",
      ]);
    }

    if (canQrCode) {
      dealConf.push([
        "icon-qrcode",
        "下载二维码",
        () => qrcodeClick(videoSet),
        "videoSet:shareUrl",
      ]);
    } else {
      dealConf.push([
        "icon-qrcode-disable",
        "下载二维码",
        () => {},
        "videoSet:shareUrl",
      ]);
    }

    dealConf.push([
      videoSet.onlineStatus == 1
        ? "iconfont icxiugaizhanshizhongduan iconfont-adapt-disabled"
        : "iconfont icxiugaizhanshizhongduan iconfont-adapt",
      "修改展示终端",
      videoSet.onlineStatus == 1 ? () => {} : () => changePort(videoSet),
      "videoSet:updateDisplay",
    ]);

    return (
      <div class="deal-group">
        {dealConf.map((item) => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };
  const CreateDate = ({ props: { vo } }) => {
    const createDate = vo.row.createDate ? vo.row.createDate : "--";
    const onlineDate = vo.row.onlineDate ? vo.row.onlineDate : "--";
    return (
      <div>
        <div>
          上线：<span>{onlineDate}</span>
        </div>
        <div>
          创建：<span>{createDate}</span>
        </div>
      </div>
    );
  };
  const ShareDeptName = ({ props: { vo } }) => {
    return <span>{vo.row.shareDeptName || "--"}</span>;
  };
  const FormDeptName = ({ props: { vo } }) => {
    return <span>{vo.row.formDeptName || "--"}</span>;
  };

  const VideoName = ({ props: { vo } }) => {
    const row = vo.row;
    return (
      <div
        class="base-hover-char"
        onClick={() => {
          router.push({
            path: "/videoSet/detail",
            query: { uuid: vo.row.uuid },
          });
        }}
      >
        {row.videoSetName}
      </div>
    );
  };

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main",
    },
    {
      label: "视频集名称",
      minWidth: "240",
      fixed: "left",
      render: (vo) => <VideoName vo={vo} />,
    },
    {
      label: "分类",
      prop: "categoryName",
      minWidth: "140",
    },
    {
      label: "来源",
      prop: "videoSourceName",
      minWidth: "140",
    },
    {
      label: "状态",
      prop: "onlineStatusName",
      minWidth: "60",
    },
    {
      label: "展示终端",
      prop: "displayTypeName",
      minWidth: "120",
    },
    {
      label: "创建者",
      prop: "createUserName",
      minWidth: "90",
      showOverflowTooltip: true,
    },
    {
      label: "已共享学院",
      prop: "shareDeptName",
      minWidth: "150",
      render: (vo) => <ShareDeptName vo={vo} />,
      showOverflowTooltip: true,
    },
    {
      label: "上线/创建时间",
      prop: "createDate",
      width: "180",
      render: (vo) => <CreateDate vo={vo} />,
      showOverflowTooltip: true,
    },
    {
      label: "版权方",
      prop: "formDeptName",
      minWidth: "100",
      render: (vo) => <FormDeptName vo={vo} />,
      showOverflowTooltip: true,
    },
    {
      label: "操作",
      width: "130",
      fixed: "right",
      render: (vo) => <Deal vo={vo} />,
    },
  ];
  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
